// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#canvas-wrapper[data-v-0fb1ecae] canvas{max-width:100%;max-height:300px}", ""]);
// Exports
module.exports = exports;
